const CoinIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <g clip-path="url(#clip0_1_616)">
      <path
        d="M17.7737 14.3207C18.8986 12.8539 19.5097 11.058 19.5127 9.20966V11.2636C19.5094 13.096 18.9085 14.8771 17.8011 16.3369V14.3446L17.7737 14.3207Z"
        fill="#CE893D"
      />
      <path
        d="M17.8011 14.3446V16.3369C17.3118 16.9923 16.736 17.5785 16.0894 18.0794V16.0562L16.0724 16.0357C16.7134 15.5424 17.2856 14.9655 17.7737 14.3207L17.8011 14.3446Z"
        fill="#E6A71E"
      />
      <path
        d="M9.92756 0.309204C15.2199 0.309204 19.5128 4.29396 19.5128 9.20976C19.5098 11.0581 18.8986 12.854 17.7737 14.3208C17.2856 14.9657 16.7135 15.5425 16.0724 16.0358C15.5472 16.4485 14.9792 16.8032 14.3778 17.0935C13.7221 17.4133 13.0334 17.6602 12.3239 17.8297C10.7483 18.2039 9.10684 18.2039 7.53125 17.8297C6.82169 17.6602 6.13302 17.4133 5.47728 17.0935C4.87603 16.8032 4.30788 16.4485 3.78269 16.0358C3.14165 15.5425 2.56949 14.9657 2.0814 14.3208C0.956466 12.854 0.345355 11.0581 0.342346 9.20976C0.342346 4.29396 4.63516 0.309204 9.92756 0.309204V0.309204Z"
        fill="#FFCB5A"
      />
      <path
        d="M16.0887 16.0564V18.0797C15.5595 18.4954 14.9868 18.8522 14.3804 19.1443L14.377 19.1374V17.0936C14.9784 16.8033 15.5464 16.4486 16.0716 16.0359L16.0887 16.0564Z"
        fill="#CE893D"
      />
      <path
        d="M14.3774 19.1372L14.3807 19.144C13.7287 19.4638 13.0434 19.7105 12.3371 19.88L12.3234 19.8218V17.8295C13.033 17.66 13.7217 17.4132 14.3774 17.0934V19.1372Z"
        fill="#E6A71E"
      />
      <path
        d="M12.3377 19.8801C11.5484 20.0693 10.7394 20.1646 9.92767 20.1642V18.1103C10.7347 18.1118 11.5392 18.0175 12.324 17.8296V19.8219L12.3377 19.8801Z"
        fill="#CE893D"
      />
      <path
        d="M9.92685 18.1103V20.1642C9.11516 20.1646 8.30631 20.0693 7.51685 19.8801L7.53055 19.8219V17.8296C8.31533 18.0175 9.11984 18.1118 9.92685 18.1103Z"
        fill="#E6A71E"
      />
      <path
        d="M7.53174 17.8295V19.8218L7.51804 19.88C6.81182 19.7105 6.12649 19.4638 5.47443 19.144L5.47777 19.1372V17.0934C6.13351 17.4132 6.82218 17.66 7.53174 17.8295Z"
        fill="#CE893D"
      />
      <path
        d="M3.78145 16.0359C4.30665 16.4486 4.8748 16.8033 5.47605 17.0936V19.1374L5.47271 19.1443C4.86711 18.8511 4.29445 18.4942 3.7644 18.0797V16.0564L3.78145 16.0359Z"
        fill="#E6A71E"
      />
      <path
        d="M2.08131 14.3207C2.56939 14.9655 3.14156 15.5424 3.78259 16.0357L3.76554 16.0562V18.0794C3.11899 17.5785 2.54315 16.9923 2.05389 16.3369V14.3446L2.08131 14.3207Z"
        fill="#CE893D"
      />
      <path
        d="M0.342346 9.20966C0.345355 11.058 0.956466 12.8539 2.0814 14.3207L2.05399 14.3446V16.3369C0.946604 14.8771 0.345689 13.096 0.342346 11.2636V9.20966Z"
        fill="#E6A71E"
      />
      <path
        d="M17.4585 9.20967C17.4585 5.42834 14.0867 2.36309 9.92723 2.36309C5.7678 2.36309 2.396 5.42834 2.396 9.20967C2.396 12.991 5.7678 16.0562 9.92723 16.0562C14.0867 16.0562 17.4585 12.991 17.4585 9.20967Z"
        fill="#E6A71E"
      />
      <path
        d="M14.6318 13.2248L14.1638 12.7257C14.5638 12.353 14.9027 11.9195 15.1678 11.4413L15.7676 11.7706C15.4682 12.3124 15.0848 12.8033 14.6318 13.2248Z"
        fill="#FFCB5A"
      />
      <path
        d="M9.92802 15.0293C6.34142 15.0293 3.42377 12.4187 3.42377 9.20974C3.42377 6.00074 6.34142 3.39015 9.92802 3.39015C13.5146 3.39015 16.4323 6.00074 16.4323 9.20974H15.7476C15.7476 6.37834 13.137 4.07481 9.92802 4.07481C6.71902 4.07481 4.10843 6.37834 4.10843 9.20974C4.10843 12.0411 6.71902 14.3447 9.92802 14.3447C11.07 14.3502 12.1921 14.0473 13.176 13.4676L13.5267 14.0562C12.4366 14.6987 11.1934 15.035 9.92802 15.0293Z"
        fill="#FFCB5A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_616">
        <rect
          width="19.8551"
          height="19.8551"
          fill="white"
          transform="translate(0.00012207 0.309204)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default CoinIcon; 
